var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 2.182v2.944m8-2.944v2.944m4.59 3.766H3.09m5.228 3.103h1.796v6.624m2.512-6.624h2.806v3.278l-1.796.034m-1.01 3.312h2.806v-3.292l-1.796-.02m0 0h-.191M16 3.654c3.33.176 5 1.423 5 6.035v6.065c0 4.043-1 6.064-6 6.064H9c-5 0-6-2.021-6-6.064V9.689C3 5.077 4.67 3.84 8 3.654h8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal);
export default __webpack_public_path__ + "static/media/cal.e9ce0043be384fb82ebf40021a26661f.svg";
export { ForwardRef as ReactComponent };